import apiClient from "./api";
import { db } from "../firebase";
import {
  collectionGroup,
  getCountFromServer,
  query,
  where,
  Timestamp,
} from "firebase/firestore";

export const dashboardService = {
  sendDatingEmail: async (userIds) => {
    return apiClient.post("/user-email/send-dating-email", { userIds });
  },

  sendBroadcastEmail: async (dynamicTemplateData) => {
    return apiClient.post("/user-email/broadcast", {
      dynamic_template_data: dynamicTemplateData,
    });
  },

  getUserCounts: async (adminId, range, startDate, endDate) => {
    let url = `/admin/user-counts-by-adminId/${adminId}`;
    if (range === "total") {
      const today = new Date().toISOString().split("T")[0];
      url += `?startDate=2026-01-01&endDate=${today}`;
    } else if (range && range !== "custom") {
      url += `?range=${range}`;
    } else if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    return apiClient(url);
  },

  getWalkCounts: async (adminId, range, startDate, endDate) => {
    let url = `/admin/book-walk-counts/${adminId}`;
    if (range === "total") {
      const today = new Date().toISOString().split("T")[0];
      url += `?startDate=2026-01-01&endDate=${today}`;
    } else if (range && range !== "custom") {
      url += `?range=${range}`;
    } else if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    return apiClient(url);
  },

  getTreatCount: async (adminId, range, startDate, endDate) => {
    let url = `/admin/web-app-treat-count/${adminId}`;
    if (range === "total") {
      const today = new Date().toISOString().split("T")[0];
      url += `?startDate=2026-01-01&endDate=${today}`;
    } else if (range && range !== "custom") {
      url += `?range=${range}`;
    } else if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }
    return apiClient(url);
  },

  getMessageCount: async (timeFilter = "today", startDateStr, endDateStr) => {
    try {
      let messagesQuery = collectionGroup(db, "messages");
      let start = null;
      let end = null;
      const now = new Date();

      if (timeFilter === "today") {
        start = new Date(now.setHours(0, 0, 0, 0));
        end = new Date(now.setHours(23, 59, 59, 999));
      } else if (timeFilter === "past7Days") {
        start = new Date(now);
        start.setDate(start.getDate() - 7);
        start.setHours(0, 0, 0, 0);
        end = new Date();
      } else if (timeFilter === "past30Days") {
        start = new Date(now);
        start.setDate(start.getDate() - 30);
        start.setHours(0, 0, 0, 0);
        end = new Date();
      } else if (timeFilter === "custom" && startDateStr && endDateStr) {
        start = new Date(startDateStr);
        start.setHours(0, 0, 0, 0);
        end = new Date(endDateStr);
        end.setHours(23, 59, 59, 999);
      }

      if (start && end) {
        messagesQuery = query(
          messagesQuery,
          where("timestamp", ">=", Timestamp.fromDate(start)),
          where("timestamp", "<=", Timestamp.fromDate(end)),
        );
      }

      const snapshot = await getCountFromServer(messagesQuery);

      return {
        status: true,
        data: {
          total_messages: snapshot.data().count,
        },
      };
    } catch (error) {
      console.error("Error fetching message count from Firebase:", error);
      return { status: false, data: { total_messages: 0 } };
    }
  },
};
